export default "__VITE_ASSET__Dcl080x$__"